export default __webpack_public_path__ + "static/media/suparnBhaiya.b441fdb8.jpg";